__turbopack_context__.v({
  "heroContent": "hero-module-scss-module__-hNsCW__heroContent",
  "heroSection": "hero-module-scss-module__-hNsCW__heroSection",
  "heroTitle": "hero-module-scss-module__-hNsCW__heroTitle",
  "mobileTitle": "hero-module-scss-module__-hNsCW__mobileTitle",
  "titleHighlight": "hero-module-scss-module__-hNsCW__titleHighlight",
  "titleMuted": "hero-module-scss-module__-hNsCW__titleMuted",
});
